import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  FiAlertCircle, FiZap, FiUser, FiUsers, 
  FiMessageSquare, FiCalendar, FiBarChart2 
} from 'react-icons/fi';
import '../styles/Home.css';
import MangoCoins from '../images/mango-hero-render.png'; 
import AboutSection from '../components/AboutSection';
import FeaturesSection from "../components/FeaturesSection";
const Home = () => {
  const navigate = useNavigate();

  return (
    <div className="home-container">
      {/* Hero Section */}
      <main className="hero-section">
        <div className="hero-bg-text">MANGO</div>
        <div className="hero-image-container">
          <img src={MangoCoins} alt="3D Mango Coins" className="floating-asset" />
        </div>
        <div className="hero-content">
          <div className="hero-text-wrapper">
            <h1 className="hero-title">
              Take control of your <br />
              financial future. Experts <br />
              in smart asset tracking.
            </h1>
            <div className="hero-actions">
              <button className="btn-glass" onClick={() => navigate('/signup')}>
                Get started <span className="arrow-circle">→</span>
              </button>
              <button className="btn-glass" onClick={() => navigate('/login')}>
                Sign in
              </button>
            </div>
          </div>
        </div>
      </main>
      <FeaturesSection />
<AboutSection />
      
    </div>
  );
};

export default Home;